/*
 * File: EditRules.tsx
 * Project: meryl-sheep
 * -----
 * Last Modified: 06 Oct 2020 11:12:51 am
 * -----
 * Copyright (c) 2020 Elegant Software Solutions All rights reserved.
 */

import { Col, Row } from 'antd';
import { POReceiptFilters } from 'common/enums/POReceiptFilters';
import WimsicalError from 'components/atoms/WimsicalError/WimsicalError';
import { HomeControls } from 'components/organisms/HomeControls';
import { POReceiptCards } from 'components/organisms/POReceiptCards';
import { InlineStylesModel } from 'models/InlineStylesModel';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedReceipt } from 'redux/poReceipts/po-receipts-slice';
import { ReduxState } from 'redux/store';
const styles: InlineStylesModel = {
  errorMessage: {
    paddingTop: 15
  },
  searchReceiptHeadline: {
    fontSize: '17px',
    marginTop: '13px',
    marginBottom: '5px'
  },
  seperator: {
    border: '.5px solid lightgrey',
    margin: '15px 0px'
  }
};

export const Home = (): JSX.Element => {
  const { selectedReceipt, error, loading } = useSelector((state: ReduxState) => state.poReceipts);
  const dispatch = useDispatch();
  const POReceiptFilterTitles = [POReceiptFilters.MDSI_PO_NUMBER, POReceiptFilters.CUST_PO_NUMBER, POReceiptFilters.VENDOR_ACCOUNT, POReceiptFilters.VENDOR_NAME, POReceiptFilters.WAREHOUSE];

  useEffect(() => {
    if (selectedReceipt !== null) dispatch(setSelectedReceipt(null));
  }, [dispatch, selectedReceipt]);

  const ErrorJSX = (
    <WimsicalError
      title={(error?.message as string) || 'Oops something went wrong'}
      statusCode={error?.status}
      subTitle={'Please try to reload the app and try again'}
      redirectText={'Reload'}
      redirectUrl={process.env.REACT_APP_REDIRECT_URL}
    />
  );

  const POReceiptsJSX = (
    <>
      <Row style={styles.searchReceiptHeadline}>
        <Col>Search PO Receipts</Col>
      </Row>
      <HomeControls />
      <POReceiptCards />
    </>
  );

  return <>{error === null ? POReceiptsJSX : ErrorJSX} </>;
};
